// ---------------------------------------------------------------------------
// Prezio Onboard Widget — OnboardShell
// ---------------------------------------------------------------------------
// Main layout wrapper. Every step renders inside this shell.
// Structure: NavHeader → ProgressBar → LogoBar → ScrollableArea
// ---------------------------------------------------------------------------

import type { ReactNode } from 'react';
import '@/styles/variables.css';
import '@/styles/reset.css';
import styles from './OnboardShell.module.css';

interface OnboardShellProps {
  children: ReactNode;
}

export function OnboardShell({ children }: OnboardShellProps) {
  return (
    <div className={styles['shell']}>
      {children}
    </div>
  );
}

/** Scrollable middle area that holds the active step content. */
export function ShellContent({ children }: { children: ReactNode }) {
  return <main className={styles['content']}>{children}</main>;
}
